var map = {
	"./template.bet777": 1613,
	"./template.bet777.tsx": 1613,
	"./template.buffalobet": 1614,
	"./template.buffalobet.tsx": 1614,
	"./template.chromabet": 1615,
	"./template.chromabet.tsx": 1615,
	"./template.default": 670,
	"./template.default.tsx": 670,
	"./template.gigabet": 1616,
	"./template.gigabet.tsx": 1616,
	"./template.goldenbet888": 1617,
	"./template.goldenbet888.tsx": 1617,
	"./template.slambet": 1618,
	"./template.slambet.tsx": 1618,
	"./template.templebet": 1619,
	"./template.templebet.tsx": 1619,
	"./template.titanbet": 1620,
	"./template.titanbet.tsx": 1620,
	"./template.ts": 985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2453;